
import { FETCH_TEXT, STORE_TEXT,UPDATE_TEXT } from './actions'

export function noteText(state = {}, action) {
    switch (action.type) {
      case STORE_TEXT:
      case FETCH_TEXT:
        return {...state,[action.id]: action.data }
//      case UPDATE_TEXT:
//        return {[action.id]: {text: action.text} }
      default:
        return state
    }

  }
  



// WEBPACK FOOTER //
// ./src/modules/notes/reducers.js